<template>
<div class="overlay-container">
   <!-- <div class="header">
      <div class="clr"></div>
   </div>header -->
   
   <div class="content">
      <div class="zoom-image-overlay">
         
      </div>

      <div class="main-wrapper">
         <ul id="main_list">
            <div v-for="(image, index) in asset.val"
               :key="index"
               class="main-img-wrapper">
               <img :src="GALLERY_HOST + '/'+ image" :alt="'image'+index" :data-large="GALLERY_HOST + '/'+ image" data-description="" />
            </div>
         </ul>

         <!-- <slick
            ref="slick"
            :options="slickOptions">
            <div v-for="(image, index) in asset.val"
               :key="index"
               class="main-img-wrapper">
               <img :src="this.GALLERY_HOST + '/'+ image" :alt="'image'+index" :data-large="this.GALLERY_HOST + '/'+ image" data-description="" />
            </div>
         </slick> -->

         <div class="carousel-btns">
            <div class="prev-wrapper carousel-btn-wrapper">
               <img class="prev" src="./assets/img/bttn-left.svg">
            </div>

            <div class="next-wrapper carousel-btn-wrapper">
               <img class="next" src="./assets/img/bttn-right.svg">
            </div>
         </div>

         <div class="text-container">
            <span class="image-title"></span>
         </div>
      </div>

      <div class="nav-wrapper">
         <div id="tlist">
            <div v-for="(image, index) in asset.val"
               :key="index"
               class="nav-img-wrapper">
               <img :src="GALLERY_HOST + '/'+ image" :alt="'image'+index" />
            </div>
         </div>
      </div>

      <div class="overlay-bottom">
         <div class="number-counter">
            <span id="current_num">1</span>/<span id="total_num">{{asset.val.length}}</span>
         </div>
         <div class="magnify">
            <img class="bottom-icon" id="magnify" src="./assets/img/bttn-magnify.svg"/>
            <img class="bottom-icon" id="magnify_off" src="./assets/img/bttn-magnify-off.svg"/>
         </div>

         <div class="grid">
            <img class="bottom-icon" id="grid_on" src="./assets/img/bttn-grid-on.svg"/>
            <img class="bottom-icon" id="grid_off" src="./assets/img/bttn-grid-off.svg"/>
         </div>

         <img id="close_btn_gallery" class="close-btn-red bottom-icon" src="./assets/img/bttn-close.svg" @click.stop="$emit('close')">
      </div>
   </div><!-- content -->
   
</div><!-- container -->
   
</template>

<script>
import Overlay from './Overlay';
import Slick from 'vue-slick';

export default {
   extends: Overlay,

   data() {
      return {
         slickOptions: {
            slidesToShow: 1
         }
      }
   },

   mounted() {
      let titles = this.asset.title;
       $(function() {
         "use strict";

         //https://stackoverflow.com/questions/4774746/jquery-ajax-wait-until-all-images-are-loaded
         $.fn.imagesLoaded = function () {

            // get all the images (excluding those with no src attribute)
            var $imgs = $('#main_list').find('img');
            // if there's no images, just return an already resolved promise
            if (!$imgs.length) {return $.Deferred().resolve().promise();}

            // for each image, add a deferred object to the array which resolves when the image is loaded (or if loading fails)
            var dfds = [];  
            $imgs.each(function(){

               var dfd = $.Deferred();
               dfds.push(dfd);
               var img = new Image();
               img.onload = function(){dfd.resolve();}
               img.onerror = function(){dfd.resolve();}
               img.src = this.src;

            });

            // return a master promise object which will resolve when all the deferred objects have resolved
            // IE - when all the images are loaded
            return $.when.apply($,dfds);

         }

         let mainSlider = $('#main_list').slick({
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            vertical: false,
            adaptiveWidth: true,
            prevArrow: $('.prev'),
            nextArrow: $('.next'),
            customPaging: function (slider, i) {
               $('.number-counter #current_num').text(i+1);
               $('.number-counter #total_num').text(slider.slideCount);
            }
         });

         mainSlider.hide();

         let navSlider = $("#tlist").slick({
            slidesToShow: 7,
            slidesToScroll: 3,
            vertical: true,
            adaptiveHeight: true,
            asNavFor: $('#main_list'),
            focusOnSelect:true,
            arrows:false
         });

         $('#main_list').imagesLoaded().then(function() { //once all images are loaded refresh the slider
				mainSlider.slick('refresh');
            mainSlider.show();
            
            // $('#main_list .slick-list').css('top', '50%');
            // $('#main_list .slick-list').css('transform', 'translateY(-50%)');
            // $('#main_list .slick-list').css('min-height', '800px');
            // $('#main_list .slick-track').css('min-height', '800px');
            // $('#main_list .slick-track').css('display', 'flex');
            // $('#main_list .slick-track').css('align-items', 'center');
            // $('#main_list .slick-track').css('justify-content', 'center');
			})

         var slides = $("#main_list .slick-track > .slick-slide").length;
         $('#main_list').on('afterChange', function(event, slick, currentSlide, nextSlide){
            var inFocus = $('#main_list .slick-current').attr('data-slick-index');
            $('#tlist .slick-current').removeClass('slick-current');
            $('#tlist .slick-slide[data-slick-index="' + inFocus + '"]').addClass('slick-current');

            $('.number-counter #current_num').text(parseInt(inFocus)+1);
            $('.image-title').text(titles[inFocus]);
         });

         $('#grid_on').on('click', function() {
            $(this).css('display', 'none');
            $('.nav-wrapper').hide();
            $('#main_list img').hide();
            $( ".main-wrapper" ).animate({
               width: "1079px",
            }, 500, function() {
               $("#main_list")
                  .css('width', '910px')
                  .css('height', '900px');
               mainSlider.slick('refresh');
               $('#main_list img').show();
               // $('#main_list .slick-list').css('min-height', '800px');
               // $('#main_list .slick-track').css('min-height', '800px');
               // $('#main_list .slick-track').css('display', 'flex');
               // $('#main_list .slick-track').css('align-items', 'center');
               // $('#main_list .slick-track').css('justify-content', 'center');
               // $('#main_list .slick-list').css('transform', 'translateY(-50%)');
               $('.main-wrapper .text-container').css('margin-top', '0px');
            });

            $('#grid_off').css('display', 'block');
            $('#magnify').css('display', 'none');
         });

      $('#grid_off').on('click', function() {
         $(this).css('display', 'none');

         $('#main_list img').hide();
         $( ".main-wrapper" ).animate({
            width: "887px",
         }, 500, function() {
            $("#main_list")
               .css('width', '810px')
               .css('height', '800px');
            mainSlider.slick('refresh');
            $('#main_list img').show();
            $('.nav-wrapper').show();
            // $('#main_list .slick-list').css('top', '50%');
            // $('#main_list .slick-list').css('transform', 'translateY(-50%)');
            // $('#main_list .slick-list').css('min-height', '800px');
            // $('#main_list .slick-track').css('min-height', '800px');
            // $('#main_list .slick-track').css('display', 'flex');
            // $('#main_list .slick-track').css('align-items', 'center');
            // $('#main_list .slick-track').css('justify-content', 'center');
            $('.main-wrapper .text-container').css('margin-top', '50px');
         });

         $('#grid_on').css('display', 'block');
         $('#magnify').css('display', 'block');
      });

      $('#magnify').on('click', function() {
         $(this).css('display', 'none');
         $('.zoom-image-overlay')
            .append($('#main_list .slick-current img').clone())
            .addClass('active')
            .css('display', 'flex');

          $('.zoom-image-overlay img')
               .each(function() {
                  var $this = $(this);
                  if ($this.width() > $this.height()) {
                     $this.addClass('landscape');
                  } else {
                     $this.addClass('portrait');
                  }
               });

         $('#magnify_off').css('display', 'block');
         $('#grid_on').css('display', 'none');
      });

      $('#magnify_off').on('click', function() {
         $(this).css('display', 'none');
         $('.zoom-image-overlay')
            .empty()
            .removeClass('active')
            .css('display', 'none');
         $('#magnify').css('display', 'block');
         $('#grid_on').css('display', 'block');
      });
       });
   }, 

   components: {
      Slick
   }
}
</script>

<style lang="scss" scoped>
.content {
   position: absolute;
   z-index: 2;
   margin: auto;
   top: 0px;
   bottom: 0;
   right: 0;
   left: 0;
   width:1078px;
   height: 1322px;
   overflow: hidden;
}

.zoom-image-overlay {
   position: absolute;
   z-index: 3;
   margin: auto;
   top: -106px;
   bottom: 0;
   right: 0;
   left: 0;
   width: 1078px;
   height: 1322px;
   display: none;
	align-items: center;
	justify-content: center;
}

.zoom-image-overlay img{
   margin: 0 auto;
   max-width: 100%;
	max-height: 100%;
   
   &.landscape {
      height: auto;
      width: 100%;
   }

   &.portrait {
      height: 100%;
      width: auto;
   }
}

.main-wrapper {
   padding-top: 200px;
   background: #353434;
   width: 887px;
   height: 1070px;
   padding-top: 200px;
   position: relative;
   box-sizing: unset;
}

#main_list {
   width: 810px;
   height: 800px;
   margin: 0 auto;
   // display: flex;
   // align-items: center;

}

.slick-list {
   top: 50% !important;
   transform: translate(-50%) !important;
}

#main_list img {
   // margin: 0 auto;
   max-height: 800px;
   max-width: 100%;
}

.carousel-btns {
  
}

.carousel-btns img {
   width: 70px;
   height: 61px;
}

.carousel-btn-wrapper {
   position: absolute;
   top: 570px;
}

.prev-wrapper {
   left: 7px;
}

.next-wrapper {
   right: 7px;
}

.nav-wrapper {
   background: #9a989a;
   width: 185px;
   height: 1078px;
   position: absolute;
   right: 6px;
   bottom: 52px;
   display: flex;
   justify-content: center;
   align-items: center;
   padding: 30px 0;
}

#tlist {
   width: 175px;
}

.nav-img-wrapper {
   margin-bottom: 10px;
   position:relative;
}

#tlist img {
   height: 129px;
	margin: 0 auto;
	max-height: 129px; 
   box-sizing: border-box;
   border: 1px solid white;
}

#tlist .slick-current img {
	border: 4px solid #f79d31;
}

.text-container {
   text-align: center;
   margin-top: 50px;
	padding: 0 30px;
}

.image-title {
   font-size: 34px;
   line-height: 35px;
   color: white;
}

.img-overlay {
   position: absolute;
   width: 173px;
   height: 129px;
   box-sizing: border-box;
   border: 1px solid white;
}

.slick-current .img-overlay {
   border: 11px solid #f79d31;
}

.overlay-bottom {
   background: black;
   padding: 10px;
   color: white;

   display: flex;
   align-items: center;
}

.bottom-icon {
   width: 30px;
   height: 30px;
}

#close_btn_gallery {
   position: absolute;
   right: 7px;
}

.number-counter {
   font-size: 24px;
   margin-right: 600px;
}

.magnify {
   margin-right: 50px;
}

#grid_off {
   display: none;
}

#magnify_off {
	display: none;
}

.main-img-wrapper {
   display: flex !important;
   justify-content: center;
   align-items: center;
   height: 800px;
}

</style>
